import { render, staticRenderFns } from "./CustomLoaderComponent.vue?vue&type=template&id=378d65f9&scoped=true"
import script from "./CustomLoaderComponent.vue?vue&type=script&lang=js"
export * from "./CustomLoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomLoaderComponent.vue?vue&type=style&index=0&id=378d65f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d65f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JienaLiu\\Documents\\bookingEngine\\BookingEngineFrontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378d65f9')) {
      api.createRecord('378d65f9', component.options)
    } else {
      api.reload('378d65f9', component.options)
    }
    module.hot.accept("./CustomLoaderComponent.vue?vue&type=template&id=378d65f9&scoped=true", function () {
      api.rerender('378d65f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomLoaderComponent.vue"
export default component.exports